import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { ShellComponent } from './shell.component';
import { HeaderComponent } from './header/header.component';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

@NgModule({
  imports: [CommonModule, TranslateModule, RouterModule, TooltipModule],
  declarations: [HeaderComponent, ShellComponent]
})
export class ShellModule {}
